'use strict'
import IMask from 'imask';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('input.phone_mask').forEach(input => {
        IMask(input, {
            mask: [
                {
                    mask: '+000 00 000-00-00',
                    startsWith: '375',
                    lazy: false,
                    country: 'Belarus'
                },
                {
                    mask: '00 00 000-00-00',
                    startsWith: '80',
                    lazy: false,
                    country: 'Belarus'
                },
                {
                    mask: '+0 000 000-00-00',
                    startsWith: '7',
                    lazy: false,
                    country: 'Russia'
                },
                {
                    mask: '0000000000000',
                    startsWith: '',
                    country: 'unknown'
                }
            ],
            dispatch: (appended, dynamicMasked) => {
                const number = (dynamicMasked.value + appended).replace(/\D/g, '');
                return dynamicMasked.compiledMasks.find(m => number.indexOf(m.startsWith) === 0);
            }
        })
    })
})